module.exports = __webpack_public_path__ + "static/media/orange-stories-img-001.ee8a2afc.jpg";